import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state() {
    return {
      type: 'dossier', // facturation, user, ...
      filters: [],
      x_axis: 'month',
      activeContextFilters: {
        funeralHomes: [],
        companies: [],
        responsables: [],
        compareMode: 'full', // 'full' | 'today'
        dateStart: null,
        dateEnd: null,
        basedOn: 'element_date',
        granularity: 'month',
        selectedPeriod: 'this_month',
      }
    }
  },
  getters,
  actions,
  mutations
}
